import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  detailsBoxContainer: {
    '&:last-of-type .detailsBoxContainerDashed': {
      transform: 'translateY(2rem)',
      flexGrow: 0
    }
  },
  detailsContent: {
    marginBottom: theme.spacing(2),
    padding: `0 ${theme.spacing(2)}`,
    borderRadius: 4,
    flex: 1
  },
  detailsBoxContainerConnectors: {
    position: 'relative'
  },
  detailsBoxContainerIcon: {
    position: 'absolute',
    top: theme.spacing(2),
    left: 0,
    width: '100%',
    textAlign: 'center',
    color: theme.vars.palette.transparent.a50,
    fontSize: '1rem',
    backgroundColor: theme.vars.palette.background.elevation2,
    padding: theme.spacing(0.25, 0)
  },
  detailsBoxContainerDashed: {
    borderLeft: `1px dashed ${theme.vars.palette.transparent.a50}`,
    flexGrow: 1,
    margin: theme.spacing(0.25, 3),
    transform: 'translateY(2.5rem)'
  },
  upperTextBox: {
    backgroundColor: theme.vars.palette.background.elevation1,
    border: `1px solid ${theme.vars.palette.divider}`,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 4,
    flex: 1
  },
  lowerTextStep: {
    backgroundColor: theme.vars.palette.background.elevation1,
    border: `1px solid ${theme.vars.palette.divider}`,
    padding: theme.spacing(2),
    borderRadius: 4,
    flex: 1,
    '& .MuiStepLabel-label': {
      fontWeight: '800 !important',
      color: 'var(--mui-palette-text-primary) !important'
    }
  }
}));

export default useStyles;
